import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';

interface ConfirmDeleteClarificationFieldDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fieldName: string;
  deleting: boolean;
  deleteError: string | null;
}

const ConfirmDeleteClarificationFieldDialog: React.FC<ConfirmDeleteClarificationFieldDialogProps> = ({
  open,
  onClose,
  onConfirm,
  fieldName,
  deleting,
  deleteError,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar Eliminación</DialogTitle>
      <DialogContent>
        {deleteError && (
          <Alert severity="error" sx={{ mb: 2 }}>{deleteError}</Alert>
        )}
        <Typography>
          ¿Está seguro de que desea eliminar el campo de clarificación <strong>"{fieldName}"</strong>? Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={deleting}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={20} /> : null}
        >
          {deleting ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteClarificationFieldDialog;
